import {fetchStudentContestResultRequest} from 'APIs/letrusAPI/studentContestResult';

function useShouldShowContestResult() {
  const studentContestResultRequest = fetchStudentContestResultRequest();

  return {
    ...studentContestResultRequest,
    shouldShowContestResult:
      studentContestResultRequest.data?.is_result_available === true,
  };
}

export default useShouldShowContestResult;
